<script>

/**
 * oss资源访问根路径
 */
const ossServer = "https://img.taimaker.com/web2.0/"; // 生产环境

/**
 * api接口访问根路径
 */
const apiServer = "https://www.taimaker.com/"; // 生产环境

export default
{
  ossServer,apiServer
}

</script>



// WEBPACK FOOTER //
// src/Global.vue